.button {
  display: block;
  height: auto;
  padding: 0;
  border-radius: var(--rc-theme-border-radius-lg);
  text-align: left;
}

.root {
  position: relative;
  padding: var(--rc-theme-spacing-ms) var(--rc-theme-spacing-xs);
}

.root:hover {
  .actions {
    transform: translateX(0);
    opacity: 1;
    pointer-events: auto;
    margin-inline-start: 0;
  }
}

.content {
  min-width: 0;
}

.actions {
  --actions-inline-size: 20px;

  flex-shrink: 0;
  transform: translateX(var(--actions-inline-size));
  transition:
    margin-inline-start 200ms ease,
    opacity 200ms ease,
    transform 200ms ease;
  opacity: 0;
  pointer-events: none;
  margin-inline-start: calc(-1 * var(--actions-inline-size));
}
